import { render, staticRenderFns } from "./KusLineGridForexNumber.vue?vue&type=template&id=465f1e2a"
import script from "./KusLineGridForexNumber.vue?vue&type=script&lang=js"
export * from "./KusLineGridForexNumber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports